<template>
  <div class="recipe">
    <myNav />
    <div class="bannerBox">
      <div class="swiper-container gallery-top">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in banner"
            :key="index"
          >
            <div
              :style="{
                background: 'url(' + item.url + ') no-repeat top center',
              }"
              class="sbanner"
            ></div>
          </div>
        </div>
      </div>
      <div class="bottomsw">
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide swiper-bottom navpic"
              v-for="(item, index) of banner"
              :key="index"
              @click="tolist(item.desc)"
            >
              <div
                :style="{
                  background: 'url(' + item.pic + ') no-repeat center',
                }"
              >
                <div class="tt">{{ item.desc }}</div>
                <div class="hei"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about">
      <div class="y1200">
        <div class="about_t">ABOUT US/关于我们</div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide about_b"
              v-for="(item, index) in info"
              :key="index"
            >
              <div class="about_left">
                <div><img :src="item.pic" /></div>
                <p>
                  <span class="about_f">{{ item.title }}</span
                  ><span class="about_n"
                    >{{ index + 1 }}/{{ info.length }}</span
                  >
                </p>
              </div>
              <div class="about_right">
                <h1>{{ item.keyword }}</h1>
                <p v-html="item.desc"></p>
              </div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="mpart1">
      <div class="we">我们的财务服务平台——专业代账及审计</div>
    </div>
    <div class="mpart2">
      <div class="y1200">
        <div class="mpart2_part">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide k"
                v-for="(item, index) of agent"
                :key="index"
                @click="todetail(item.agent_id)"
              >
                <img :src="item.logo" />
                <h1>{{ item.company_name }}</h1>
                <p v-html="item.desc"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link class="mpart3" :to="{ name: 'about' }"></router-link>
    <div class="mpart4">
      <div class="y1200">
        <div class="mpart4_left">
          <div
            class="mpart4_left_part"
            v-for="(item, index) of company"
            :key="index"
          >
            <img :src="item.logo" />
          </div>
        </div>
        <div class="mpart4_right">
          <div class="logo"><img :src="about.pic" /></div>
          <router-link class="ckxq" :to="{ name: 'about' }"
            ><img src="../assets/images/index_ckxq.jpg"
          /></router-link>
          <div class="con_4">
            <h1>利源诚企服</h1>
            <p v-html="about.desc"></p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
import Swiper from "swiper";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      // 数据
      banner: [],
      agent: [],
      company: [],
      info: [],
      link: [],
      about: [],
      ainfo: [],
      map: [],
      type: [],
      //
      activeName: "1",
      classifyType: "", // 记录菜谱分类的类型
      classifies: [], // 菜谱分类
      properties: [], // 属性分类
      propertiesActivName: [], // 记录多个属性分类
      propertiesTypes: {}, // 记录属性的分类，有多个  {a:'1-2',b:'2-1'}
      list: [],
      pages: {
        pageSize: 0,
        total: 0,
        currentPage: 0,
        totalPages: 0,
      },
      loading: false,
    };
  },
  created() {
    this.getIndex();
    setTimeout(() => {
      this.galleryThumbsLunbo();
      this.galleryTopLunbo();
    }, 500);
  },
  mounted() {
    new Swiper(".banner .swiper-container", {
      autoplay: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    new Swiper(".about .swiper-container", {
      autoplay: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    new Swiper(".mpart2 .swiper-container", {
      autoplay: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
      loop: true,
      loopFillGroupWithBlank: true,
      direction: 'vertical',
    });
  },
  methods: {
    galleryThumbsLunbo() {
      this.galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 1,
        slidesPerView: 4, //设置slider容器能够同时显示的slides数量
        loop: true, //设置为true 则开启loop模式
        freeMode: true, //默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5, //一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true, //开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true, //开启这个参数来计算每个slide的progress(进度、进程)
        autoplay: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
    },
    galleryTopLunbo() {
      this.galleryTop = new Swiper(".gallery-top", {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // 左右按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          //thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs,
        },
      });
    },
    getIndex() {
      this.$axios({
        url: "Index/indexinfo",
        method: "GET",
        params: {},
      }).then((res) => {
        console.log(res, "sss");
        this.banner = res.data.data.banner;
        this.agent = res.data.data.agent;
        this.company = res.data.data.company;
        this.info = res.data.data.info;
        this.link = res.data.data.link;
      });
      this.$axios({
        url: "Index/about",
        method: "GET",
        params: {},
      }).then((res) => {
        this.about = res.data.data.about;
        this.ainfo = res.data.data.info;
        this.map = res.data.data.map;
        this.type = res.data.data.type;
      });
    },
    tolist(e) {
      console.log(e, "e是啥");
      if (e == "代账") {
        this.$router.push({
          path: "dz",
        });
      }
      if (e == "审计") {
        this.$router.push({
          path: "sj",
        });
      }
      if (e == "财税培训") {
        this.$router.push({
          path: "cs",
        });
      }
      if (e == "税务资讯") {
        this.$router.push({
          path: "sz",
        });
      }
    },
    todetail(e) {
      this.$router.push({
        path: "dz_detail",
        query: {
          admin_id: e,
        },
      });
    },
  },
};
</script>
<style scoped>
.banner {
  width: 100%;
  height: 500px;
  position: relative;
}
.sbanner {
  width: 100%;
  height: 500px;
}
.gallery-thumbs img {
  border: 1px solid #ccd2e7;
  border-radius: 4px;
}
.img {
  width: 30px;
  height: 30px;
}
.swiper-slide-thumb-active div {
  background: #281bcc !important;
  width: 100%;
  height: 130px;
  float: left;
  font-size: 40px;
  font-weight: bolder;
  line-height: 130px;
  text-align: center;
}
.mpart1 {
  background: url(../assets/images/index_3bg.jpg) no-repeat;
  width: 100%;
  height: 504px;
  background-position: top center;
}
.mpart2 {
  background: url(../assets/images/index_3bg2.jpg) no-repeat;
  width: 100%;
  height: 702px;
  background-position: top center;
}
.mpart3 {
  background: url(../assets/images/index_3bg3.jpg) no-repeat;
  width: 100%;
  height: 621px;
  background-position: top center;
  display: block;
}
.mpart4 {
  width: 100%;
  height: 838px;
}
.mpart4_left {
  width: 807px;
  height: 838px;
  float: left;
}
.mpart4_left_part {
  width: 267px;
  height: 180px;
  float: left;
  border: 1px solid #535353;
  box-sizing: content-box;
}
.mpart4_left_part img {
  width: 267px;
  height: 180px;
  object-fit: contain;
}
.mpart4_right {
  background: #535353;
  width: 393px;
  height: 838px;
  float: right;
}
.aa {
  width: 300px;
  margin: 0 auto;
  position: absolute;
}
.banner_down {
  width: 100px;
  height: 100px;
  float: left;
}
.about {
  height: 560px;
}
.about_t {
  font-size: 30px;
  font-weight: 800;
  padding-top: 130px;
  padding-bottom: 70px;
}
.about_left {
  width: 750px;
  float: left;
}
.about_left p {
  font-size: 20px;
  font-weight: 800;
  padding-left: 120px;
  padding-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about_n {
  float: right;
}
.about_b {
  width: 100%;
  height: 360px;
  background: #fff;
}
.about_left img {
  width: 750px;
  height: 272px;
  object-fit: cover;
}
.about_right {
  float: right;
  text-align: left;
  width: 390px;
}
.about_right h1 {
  padding-top: 34px;
  border-bottom: 1px solid #535353;
  color: #535353;
  font-size: 18px;
  padding-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.about_right p {
  padding-top: 34px;
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.about .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  right: 100px;
  left: auto;
  top: 283px;
  background: #281bcc;
  width: 100px;
  height: 100px;
  color: #fff;
}
.about .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  top: 283px;
  background: #281bcc;
  width: 100px;
  height: 100px;
  color: #fff;
  right: 0;
}
.mpart2_part {
  width: 500px;
  float: right;
}
.mpart2_part .swiper-container{
  height: 700px;
}
.mpart2_part .k {
  width: 100%;
  height: 232px;
  border-bottom: 1px solid #535353;
  display: block;
}
.mpart2_part .k img {
  height: 150px;
  object-fit: cover;
  float: left;
  padding-top: 50px;
  padding-left: 30px;
  padding-right: 75px;
}
.mpart2_part .k p {
  font-size: 15px;
  padding-top: 10px;
  color: #281bcc;
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.mpart2_part .k h1 {
  font-size: 30px;
  padding-top: 60px;
  color: #281bcc;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.logo {
  width: 300px;
  height: 300px;
  margin: 0 auto;
}
.logo img {
  object-fit: contain;
  width: 300px;
  height: 300px;
}
.ckxq {
  width: 292px;
  height: 37px;
  margin: 0 auto;
  padding-top: 30px;
  display: block;
}
.con_4 {
  background: #281bcc;
  color: #fff;
  height: 380px;
  width: 100%;
  margin-top: 81px;
}
.con_4 h1 {
  font-size: 30px;
  font-weight: 800;
  padding-left: 20px;
  padding-top: 20px;
}
.con_4 p {
  font-size: 20px;
  padding-left: 20px;
  padding-top: 20px;
  width: 330px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 10;
  overflow: hidden;
}
.navbottom {
  width: 1188px;
  margin: 0 auto;
  position: absolute;
  bottom: -100px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50000;
}
.navpic {
  width: 297px;
  height: 130px;
  float: left;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  line-height: 130px;
  text-align: center;
}
.navpic :hover {
  background: #281bcc !important;
  display: block;
  font-size: 40px;
  font-weight: bolder;
  line-height: 130px;
  text-align: center;
  transition: 1s;
}
.hei {
  background: #0000004a;
  width: 100%;
  height: 130px;
  position: absolute;
  top: 0;
}
.tt {
  position: relative;
  z-index: 20000000;
}
.banner .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  color: #fff;
}
.banner .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  color: #fff;
}
.bottomsw {
  width: 80%;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5000000;
}
.we{
  text-align: center;
  padding-top: 100px;
  font-size: 40px;
  font-weight: 800;
}
</style>

